<template>
  <div class="container mescroll-touch">
    <div class="headerBox">
      <div class="searchBox" @click="$router.push('/search')">
        <div class="searchInput"> 
          <img class="searchIcon" src="@/assets/images/search_icon.png" />
          <span>大家都在搜</span>
        </div>
        <div class="searchBtn">搜索</div>
      </div>

      <div class="departmentBox">
        <div class="departmentListBox" ref="departmentWrapper">
          <div class="departmentList">
            <span class="departmentItem" :class="{'departmentItem_active': departmentId == item.Id}" v-for="(item, index) in departmentList" :key="index" @click="departmentChange(item.Id, item.Code, item.TCode, item.DisplayName)">
              {{ item.DisplayName }}
              <!-- <van-icon v-if="departmentId == item.Id" class="expandIcon" name="play" /> -->
            </span>
          </div>
        </div>
        <div class="moreDepartment">
          <span @click="$router.push('/interest')">{{userInfo.Type != 3 ? '更多...' : 'More...'}}</span>
        </div>
      </div>

      <!-- <div class="techniqueBox" v-if="techniqueShow">
        <div class="techniqueList">
          <span :class="{'technique_active': techniqueActiveListTemp.indexOf(0) !== -1}" @click="selectTechnique(0, code + '|', '全部')">ALL</span>
          <span :class="{'technique_active': techniqueActiveListTemp.indexOf(parseInt(item.Value)) !== -1}" v-for="item in techniqueList" :key="item.Value" @click="selectTechnique(item.Value, item.TCcode, item.Name)">{{ item.Name }}</span>
        </div>
        <div class="btnBox">
          <div class="resetBtn" @click="resetTechnique">重置</div>
          <div class="confirmBtn" @click="confirmTechnique">确定</div>
        </div>
      </div> -->
    </div>
    <div class="contentBox" id="toTop">
      <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="bannerBox" v-if="bannerList.length > 0">
        <swiper class="bannerSwiper" ref="bannerSwiper" :options="bannerSwiperOptions" @click="(event) => handleBannerClick(event)">
          <swiper-slide v-for="(item, index) in bannerList" :key="index">
            <img :src="item.File_Url" alt="" srcset="">
          </swiper-slide>
        </swiper>
      </div>
      <div class="ListBox">
        <div class="filterBox">
          <div class="filterItem" :class="{'filterItem_active': ModuleType == 1}" @click="changeModuleType(1)">
            <span>{{userInfo.Type != 3 ? '全部活动' : 'Live'}}</span>
          </div>
          <div class="filterItem" :class="{'filterItem_active': ModuleType == 3}" @click="changeModuleType(3)">
            <span>{{userInfo.Type != 3 ? '活动专区' : 'Events'}}</span>
          </div>
          <div class="filterItem" :class="{'filterItem_active': ModuleType == 2}" @click="changeModuleType(2)">
            <span>{{userInfo.Type != 3 ? '我的预约' : 'Booking'}}</span>
          </div>
          <div class="filterItem" @click="changeModuleType(4)">
            <span>{{userInfo.Type != 3 ? '星光' : 'XingGuang'}}</span>
          </div>
        </div>
        <div class="ClassificationBox" v-if="ModuleType == 1">
          <span class="ClassificationItem" :class="{'ClassificationItem_active': DayType == null}" @click="changeDayType(null)">{{userInfo.Type != 3 ? '全部' : 'ALL'}}</span>
          <span class="ClassificationItem" :class="{'ClassificationItem_active': DayType == 1}" @click="changeDayType(1)">{{userInfo.Type != 3 ? '近一天' : '≤1Days'}}</span>
          <span class="ClassificationItem" :class="{'ClassificationItem_active': DayType == 2}" @click="changeDayType(2)">{{userInfo.Type != 3 ? '近一周' : '≤7Days'}}</span>
          <span class="ClassificationItem" :class="{'ClassificationItem_active': DayType == 3}" @click="changeDayType(3)">{{userInfo.Type != 3 ? '活动日历' : 'Calendar'}}<img class="calendarIcon" src="@/assets/images/calendarIcon1.png" /></span>
        </div>

        <!-- <div class="topLiveBox" v-if="ModuleType == 1 && topLiveList.length > 0">
          <van-swipe class="topLiveSwipe" :autoplay="3000" :show-indicators="false" vertical @change="topLiveSwipeChange">
            <van-swipe-item v-for="(item, index) in topLiveList" :key="index" @click="toContentPage(item.Id, item.Type)">
              <div class="topLiveItem">
                <div class="live-cover">
                  <img class="cover" :src="item.Thumbnail" alt="">
                  <div class="liveStatus liveStreaming" v-if="item.LiveStatus == 1">
                    <img class="liveStatusIcon" src="@/assets/images/live1.png" />
                    <span class="liveStatusText">进行中</span>
                  </div>
                  <div class="liveStatus noLive" v-if="item.LiveStatus == 2">
                    <img class="liveStatusIcon" src="@/assets/images/notLive.png" />
                    <span class="liveStatusText">未开始</span>
                  </div>
                </div>
                <div class="live-info">
                  <p class="live-title van-multi-ellipsis--l2">{{ item.Title }}</p>
                  <p class="live-time">开始时间：{{ item.StartTime ? item.StartTime.replace('T', ' ') : '' }}</p>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="custom-indicator-wrapper">
            <span class="custom-dot" :class="{'custom-dot--active': topLiveCurrent == index}" v-for="(item, index) in topLiveList" :key="index"></span>
          </div>
        </div> -->

        <div class="timeline" id="dataList" v-if="ModuleType != 3">
          <div class="timeline-item" v-for="(item, index) in groupList" :key="index">
            <div class="timeline-marker" :class="{'timeline-marker_active': item.highlight && ModuleType == 1}">{{ item.date }}</div>
            <div class="timeline-content">
              <div class="live-time">{{ item.Start }}</div>
              <div class="live-item" v-for="(children, childrenIndex) in item.list" :key="childrenIndex" @click="toContentPage(children.Id, children.Type)">
                <div class="live-cover">
                  <img class="cover" :src="children.Thumbnail" alt="">
                  <span class="activityLabel" v-if="children.Type == 4">系列活动</span>
                  <div class="liveStatus liveStreaming" v-if="children.Type != 4 && children.LiveStatus == 1">
                    <img class="liveStatusIcon" src="@/assets/images/live1.png" />
                    <span class="liveStatusText">进行中</span>
                  </div>
                  <div class="liveStatus noLive" v-if="children.Type != 4 && children.LiveStatus == 2">
                    <img class="liveStatusIcon" src="@/assets/images/notLive.png" />
                    <span class="liveStatusText">未开始</span>
                  </div>
                  <div class="liveStatus noLive" v-if="children.Type != 4 && children.LiveStatus == 3">
                    <img class="liveStatusIcon" src="@/assets/images/notLive.png" />
                    <span class="liveStatusText">已结束</span>
                  </div>
                </div>
                <div class="live-info">
                  <p class="live-title van-multi-ellipsis--l2">{{ children.Title }}</p>
                  <p class="live-time">开始时间：{{ children.StartTime ? children.StartTime.replace('T', ' ') : '' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="activityList" id="dataList" v-else>
          <div class="activityItem" v-for="(item, index) in list" :key="index" @click="toActivityDetails(item.Id)">
            <img class="cover" :src="item.Thumbnail" />
            <div class="info">
              <p class="title van-multi-ellipsis--l2">{{ item.Title }}</p>
              <p class="time">{{ item.StartTime | timeQuantum(item.EndTime) }}</p>
            </div>
          </div>
        </div>

      </div>
      </mescroll-vue>
    </div>

    <van-overlay :show="calendarShow">
      <div class="calendarOverlayBox" @click.stop>
        <div class="calendarBox">
          <Calendar :selectedDate="selectedDate" :dataDates="dataDates" @select-day="handleSelectDay" @change-month="handleChangeMonth" />
          <div class="handle">
            <div class="btn cancel" @click="calendarCancel">取消</div>
            <div class="btn confirm" @click="calendarConfirm">确认</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import { mapState } from 'vuex'
import BScroll from 'better-scroll'
import MescrollVue from 'mescroll.js/mescroll.vue'
import Calendar from '../../components/Calendar.vue';

export default {
  name: 'Department',
  data() {
    return {
      code: '',
      departmentId: '',
      departmentList: [],
      techniqueShow: false,
      techniqueList: [],
      techniqueActiveList: [0],
      techniqueActiveListTemp: [0],
      bannerList: [],
      bannerSwiperOptions: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: true,
        simulateTouch: true,
        touchRatio: 1,
        speed: 500,
        effect: 'slide',
        slideToClickedSlide: true
      },
      ModuleType: 1,
      DayType: null,
      calendarShow: false,
      selectedDate: new Date(),
      confirmdDate: new Date(),
      dataDates: [],
      time: '',
      topLiveCurrent: 0,
      topLiveList: [],
      list: [],
      groupList: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      scrollTop: 0, // 记录离开页面时的滚动位置，用于返回时恢复
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 10 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '<p class="upwarp-nodata">-- END --</p>',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_icon_1103.png' // 回到顶部按钮的图片路径,支持网络图
        },
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'dataList', // 父布局的id;
          icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
          tip: '暂无内容', // 提示
        },
			},
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue,
    Calendar
  },
  computed: {
    ...mapState(['userInfo']),
    sid() {
      return this.$route.query.sid;
    },
    firstTechniqueName() {
      if(this.techniqueActiveList.length > 0 && this.techniqueActiveList[0] != 0) {
        const firstTechnique = this.techniqueList.find(item => item.Value == this.techniqueActiveList[0]);
        return firstTechnique ? firstTechnique.Name.slice(0, 3) : '';
      } else {
        return ''
      }
    }
  },
   watch: {
    departmentList() {
      this.$nextTick(() => {
        this.departmentScroll.refresh();
        let el = document.querySelector(".departmentItem_active");
        this.departmentScroll.scrollToElement(el, 0, 0);
      })
    },
    departmentId() {
      this.getBanner();
      this.getTechnique();
      this.groupList = [];
      this.list = [];
      this.mescroll.resetUpScroll();
      let date = new Date();
      this.getHasData(date);
      this.BuriedPoint(6, '直播', '', `/liveList?id=${this.departmentId}&code=${this.code}`, this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    }
  },
  created() {
    if(this.$route.query.id) {
      this.departmentId = this.$route.query.id;
    }
    if(this.$route.query.code) {
      this.code = this.$route.query.code;
    }
    if(this.sid) { 
      this.$set(this.techniqueActiveList, 0, parseInt(this.sid));
    }

    this.getDepartment();
    // this.getBanner();
    // this.getTechnique();

    let date = new Date();
    this.time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  },
  mounted() {
    this.initDepartmentBScroll();
  },
  activated(){
    wx.miniProgram.postMessage({
      data: {
        share: {
          title: '科室活动',
          imageUrl: '',
          path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/liveList?id=${this.departmentId}&code=${this.code}&sourceType=7`)}`,
          contentId: ''
        }
      }
    })
    // this.BuriedPoint(6, '直播', '', `/liveList?id=${this.departmentId}&code=${this.code}`, this.$route.query.sourceId ? this.$route.query.sourceId : '', '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    this.$store.commit('changeNavbarIndex', 1);

    if(this.scrollTop > 0 && this.$refs.mescroll) {
      this.$refs.mescroll.$el.scrollTop = this.scrollTop;
    }
  },
  methods: {
    // 初始化科室BScroll
    initDepartmentBScroll() {
      this.$nextTick(() => {
        this.departmentScroll = new BScroll(this.$refs['departmentWrapper'], {
          startX: 0,
          click: true,
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical'
        })
      })
    },
    // 获取科室
    getDepartment() {
      this.$axios.post('/Api/Api/Web/Subject/GetUserDepartmentList?WebCode=' + sessionStorage.getItem('random')).then(res => {
        this.departmentList = res.Data;
        if(!this.departmentId || !this.code) {
          const department = this.departmentList.find(item => item.DisplayName == this.userInfo.SubjectName);
          if(department) {
            this.departmentId = department.Id;
            this.code = department.Code;
          }
        }
        // 数据渲染完成后重新计算滚动范围
        this.$nextTick(() => {
          this.departmentScroll && this.departmentScroll.refresh();
        })
      })
    },
    // 获取术式
    getTechnique() {
      this.$axios.post('/Api/Api/Web/Customer/GetDitWebCode?type=2&pcode=' + this.code).then(res => {
        this.techniqueList = res.Data;
      })
    },
    // 获取Banner
    getBanner() {
      this.$axios.post('/Api/api/Web/ImgFile/GetImgFileListByCode', {
        PageType: 2,
        Code: this.code,
        WebCode: sessionStorage.getItem('random')
      }).then(res => {
        this.bannerList = res.Data;

        if (this.bannerList.length === 1) {
          const copy = JSON.parse(JSON.stringify(this.bannerList[0]));
          this.bannerList.push(copy);
        }
      })
    },
    // getTopLiveList() {
    //   this.$axios.post('/Api/api/Web/Article/GetTopLiveList', {
    //     SubId: this.departmentId,
    //     IsIntraday: 1,
    //     DayType: this.DayType,
    //     time: this.time,
    //     WebCode: sessionStorage.getItem('random')
    //   }).then(res => {
    //     this.topLiveList = res.Data;
    //     this.topLiveCurrent = 0;
    //   })
    // },
    // 顶部直播轮播切换
    topLiveSwipeChange(index) {
      this.topLiveCurrent = index;
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
		mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      this.$refs.mescroll.$el.addEventListener('scroll', () => {
        this.scrollTop = this.$refs.mescroll.$el.scrollTop
      })
		},
    // 上拉回调
		upCallback (page) {
      if(this.departmentId) {
        if(this.ModuleType == 3) {
          this.getActivityList(page.num, page.size);
        } else {
          this.getList(page.num, page.size);
        }
      }
		},
    // 获取活动和预约列表数据
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetNewLiveList', {
          SubId: parseInt(this.departmentId),
          DayType: this.DayType,
          time: this.time,
          IsIntraday: this.ModuleType,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize,
          WebCode: sessionStorage.getItem('random')
        }).then((res) => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr);

          if(this.ModuleType == 1) {
            const today = new Date().toISOString().split('T')[0];
            // 第一步：分组并标记每个 item 的归类方式
            const groupedDate = this.list.reduce((acc, cur) => {
              let key = '';
              let highlight = false; // 默认按开始时间归类

              if (cur.StartTime && cur.EndTime) {
                const startDate = cur.StartTime.split('T')[0];
                const endDate = cur.EndTime.split('T')[0];

                if (today >= startDate && today <= endDate) {
                  key = today;        // 归到今天的日期
                  highlight = true;   // 按当前日期归类 → 高亮标记
                } else {
                  key = startDate;    // 归到开始日期
                  highlight = false;  // 按开始时间归类 → 不高亮标记
                }
              } else if (cur.StartTime) {
                key = cur.StartTime.split('T')[0];
                highlight = false;    // 没有结束时间，只能按开始日期归类
              }
              // 无开始时间 → key='', highlight=false
              if (!acc[key]) acc[key] = [];
              acc[key].push({ ...cur, highlight });
              return acc;
            }, {});
            // 第二步：生成最终分组数组，计算分组级 highlight
            const groupList = Object.entries(groupedDate).map(([date, list]) => ({
              date,
              list,
              // 分组高亮：组内至少有一个 item 是按当前日期归类的（highlight === true）
              highlight: list.some(item => item.highlight)
            }));
            this.groupList = groupList;
          } else {
            const groupedDate = this.list.reduce((acc, cur) => {
            const key = cur.StartTime ? cur.StartTime.split('T')[0] : '';
            if (!acc[key]) acc[key] = [];
              acc[key].push(cur);
              return acc;
            }, {});
            const groupList = Object.entries(groupedDate).map(([date, list]) => ({ date, list }));
            this.groupList = groupList;
          }

          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    // 获取活动专区列表数据
    getActivityList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      setTimeout(() => {
        this.$axios.post('/Api/Api/Web/Article/GetActivityList', {
          // SubCode: this.code,
          SubId: parseInt(this.departmentId),
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then((res) => {
          let arr = res.Data.List;
          this.Total = res.Data.Total;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr()
        })
      }, 200);
    },
    departmentChange(id, code, tcode, name) {
      if(this.departmentId != id) {
        let url = `/liveList?id=${id}&code=${this.code}`;
        this.BuriedPoint(1, name, tcode, url);
        this.$router.push({
          path: 'liveList',
          query: {
            id: id,
            code: code
          }
        })
      } else {
        // this.techniqueShow = !this.techniqueShow;
        // this.techniqueActiveListTemp = JSON.parse(JSON.stringify(this.techniqueActiveList));
      }
    },
    selectTechnique(id, TCcode, name) {
      const index = this.techniqueActiveListTemp.indexOf(parseInt(id));
      
      if (id === 0) {
        // 如果选择"全部"，清空其他科室，只保留全部
        if (index !== -1) {
          this.techniqueActiveListTemp = [];
        } else {
          this.techniqueActiveListTemp = [0];
          this.BuriedPoint(1, name, TCcode, `/department?id=${this.departmentId}&code=${this.code}`);
        }
      } else {
        // 如果选择其他科室，取消"全部"的选中状态
        const allIndex = this.techniqueActiveListTemp.indexOf(0);
        if (allIndex !== -1) {
          this.techniqueActiveListTemp.splice(allIndex, 1);
        }
        
        if (index !== -1) {
          this.techniqueActiveListTemp.splice(index, 1);
        } else {
          this.techniqueActiveListTemp.push(parseInt(id));
          this.BuriedPoint(1, name, TCcode, `/department?id=${this.departmentId}&code=${this.code}`);
        }
      }
    },
    resetTechnique() {
      this.techniqueActiveList = [0];
      this.techniqueActiveListTemp = [0];
    },
    confirmTechnique() {
      this.techniqueActiveList = JSON.parse(JSON.stringify(this.techniqueActiveListTemp));
      this.techniqueShow = false;

      this.groupList = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
    },
    handleBannerClick(event) {
      const realIndex = event.realIndex;
      const info = this.bannerList[realIndex];
      if(info.LinkType && info.UrlLink) {
        if(info.LinkType == 1) {
          location.href = info.UrlLink;
        } else if(info.LinkType == 2) {
          wx.miniProgram.navigateTo({url: info.UrlLink})
        } else if(info.LinkType == 3) {
          if (info.UrlLink.indexOf('?') !== -1) {
            info.UrlLink += '&sourceType=3&sourceId=' + info.Id;
          } else {
            info.UrlLink += '?sourceType=3&sourceId=' + info.Id;
          }
          this.$router.push(info.UrlLink);
        }
        this.BuriedPoint(3, info.DepartmentName, info.DepartmentCode, info.UrlLink, info.Id);
      }
    },
    changeModuleType(type) {
      if(type == 1 && this.ModuleType != type) {
        let date = new Date();
        this.time = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        this.ModuleType = type;
        this.DayType = null;
        this.groupList = [];
        this.list = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      } else if(type == 4) {
        wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
      } else {
        if(this.ModuleType != type) {
          this.ModuleType = type;
          this.groupList = [];
          this.list = [];
          this.mescroll.resetUpScroll() // 刷新列表数据
        }
      }
    },
    changeDayType(type) {
      if(type == 3) {
        this.calendarShow = true;
      } else if(this.DayType != type) {
        this.DayType = type;
        this.groupList = [];
        this.mescroll.resetUpScroll() // 刷新列表数据
      }
    },
    getHasData(date) {
      let StartTime = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
      let EndTime = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
      this.$axios.post('/Api/api/Web/Article/GetMonthLiveCount', {
        StateTime: StartTime,
        EndTime: EndTime,
        SubId: this.departmentId,
        WebCode: sessionStorage.getItem('random')
      }).then(res => {
        this.dataDates = res.Data;
      })
    },
    handleSelectDay(date) {
      this.selectedDate = date;
      if(date) {
        const dateString = date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '-');
        console.log(`你选择的日期是: ${dateString}`);
      }
    },
    handleChangeMonth(date) {
      this.getHasData(date);
    },
    calendarCancel() {
      this.calendarShow = false;
      this.selectedDate = this.confirmdDate;
    },
    calendarConfirm() {
      this.DayType = 3;
      this.confirmdDate = this.selectedDate;
      let confirmdDate = new Date(this.confirmdDate);
      this.time = confirmdDate.getFullYear() + '-' + (confirmdDate.getMonth() + 1) + '-' + confirmdDate.getDate();
      this.groupList = [];
      this.mescroll.resetUpScroll() // 刷新列表数据
      this.calendarShow = false;
    },
    toContentPage(id, type) {
      if(type == 4) {
        this.$router.push({
          path: 'activityDetails',
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id
          }
        });
      }
    },
    toActivityDetails(id) {
      this.$router.push({
        path: 'activityDetails',
        query: {
          id: id
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .mescroll {
    padding-bottom: 60px;
    box-sizing: border-box;
  }
  .headerBox {
    position: relative;
    z-index: 9;
    padding-top: 10px;
    background-color: #EB1700;
    box-shadow: 0 4px 12px -4px rgba(159, 0, 0, 0.3);
    box-sizing: border-box;
    .searchBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 28px;
      border-radius: 28px;
      background-color: #FFFFFF;
      padding: 0 3px 0 10px;
      box-sizing: border-box;
      margin: 0 10px;
      .searchInput {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #CACACA;
      }
      .searchIcon {
        display: block;
        width: 12px;
        margin-right: 5px;
      }
      .searchBtn {
        width: 40px;
        height: 22px;
        border-radius: 22px;
        text-align: center;
        line-height: 22px;
        font-size: 11px;
        color: #FFFFFF;
        background-color: #EB1700;
      }
    }
    .departmentBox {
      position: relative;
      height: 35px;
      line-height: 38px;
      margin-right: 10px;
      overflow: hidden;
      .departmentListBox {
        display: flex;
        overflow: hidden;
        margin-right: 40px;
      }
      .departmentList {
        white-space: nowrap;
        .departmentItem {
          position: relative;
          font-size: 14px;
          color: #FFFFFF;
          padding: 0 10px;
          .expandIcon {
            font-size: 9px;
            transform: translateY(-2px) rotate(90deg);
          }
        }
        .departmentItem_active {
          font-size: 15px;
          font-weight: bold;
        }
        .departmentItem_active::after {
          content: "";
          display: block;
          width: 60%;
          height: 4px;
          border-radius: 4px;
          background-color: #FFFFFF;
          position: absolute;
          bottom: -8px;
          left: 20%;
        }
      }
      .moreDepartment {
        position: absolute;
        width: 58px;
        top: 0px;
        right: 0px;
        font-size: 12px;
        color: #FFFFFF;
        text-align: right;
        background: linear-gradient(to right, transparent 0%, #EB1700 50%);
        z-index: 9;
      }
    }
    .techniqueBox {
      position: absolute;
      z-index: 8;
      top: 100%;
      left: 0;
      right: 0;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      padding: 8px 10px 15px;
      box-sizing: border-box;
      border-radius: 0 0 16px 16px;
      box-shadow: 0 4px 8px -4px rgba(0, 0, 0, 0.1);
      .techniqueList {
        display: flex;
        flex-wrap: wrap;
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 23%;
          height: 28px;
          line-height: 28px;
          border-radius: 28px;
          background-color: #FFFFFF;
          border: 1px solid #D1D2D9;
          font-size: 12px;
          color: #4A4A4A;
          box-sizing: border-box;
          margin-top: 10px;
        }
        span:not(:nth-child(4n)) {
          margin-right: calc(8% / 3);
        }
        .technique_active {
          border: 1px solid #EB1700;
          color: #EB1700;
        }
      }
      .btnBox {
        display: flex;
        margin-top: 12px;
        .resetBtn {
          width: 80px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          font-size: 14px;
          color: #EB1700;
          background-color: #FFFFFF;
          border-radius: 35px;
          margin-right: 15px;
          box-shadow: 0 3px 10px -4px rgba(0, 0, 0, 0.2);
        }
        .confirmBtn {
          flex: 1;
          height: 35px;
          line-height: 35px;
          text-align: center;
          font-size: 14px;
          color: #FFFFFF;
          background-color: #EB1700;
          border-radius: 35px;
          box-shadow: 0 3px 10px -4px rgba(235, 23, 0, 0.3);
        }
      }
    }
  }
  .contentBox {
    flex: 1;
    height: 0;
    .bannerBox {
      margin: 6px 0 20px;
      overflow: hidden;
      .bannerSwiper {
        padding: 0 15px;
        overflow: visible;
        ::-webkit-scrollbar {
          display: none;
        }
        ::v-deep .swiper-slide {
          width: 92%;
          margin: 0 auto;
          transition: transform 0.3s, opacity 0.3s;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px 0px;
          border-radius: 12px;
          img {
            display: block;
            width: 100%;
            object-fit: cover;
            border-radius: 12px;
          }
        }
        ::v-deep .swiper-slide:not(.swiper-slide-active) {
          transform: scale(0.94);
        }
      }
    }
    .ListBox {
      .filterBox {
        display: flex;
        height: 36px;
        padding: 4px 15px 0;
        // box-sizing: border-box;
        border-bottom: 1px solid #F4F4F4;
        box-shadow: 0 -5px 8px -6px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        .filterItem {
          position: relative;
          display: flex;
          align-items: center;
          height: 36px;
          margin-right: 20px;
          .new_icon {
            display: block;
            width: 11px;
          }
          .hot_icon {
            display: block;
            width: 8px;
          }
          span {
            font-size: 14px;
            color: #4A4A4A;
          }
        }
        .filterItem_active {
          span {
            font-weight: bold;
          }
        }
        .filterItem_active::after {
          content: "";
          width: 100%;
          height: 4px;
          border-radius: 4px;
          background-color: #EB1700;
          position: absolute;
          top: 32px;
          left: 0;
        }
      }
      .ClassificationBox {
        padding: 0px 15px;
        margin-top: 10px;
        .ClassificationItem {
          display: inline-block;
          height: 24px;
          line-height: 24px;
          border-radius: 24px;
          padding: 0 10px;
          font-size: 12px;
          color: #4A4A4A;
          background-color: #F4F4F4;
          margin-right: 6px;
          .calendarIcon {
            width: 10px;
            margin-left: 2px;
          }
        }
        .ClassificationItem_active {
          background: rgba(255, 135, 162, 0.1);
          color: #EB1700;
        }
      }
    }
  }
}
.calendarOverlayBox {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 12px;
  .calendarBox {
    background-color: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
  }
  .handle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15%;
    margin: 10px 0 15px;
    .btn {
      width: 90px;
      height: 34px;
      line-height: 34px;
      border-radius: 34px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }
    .cancel {
      color: #CA001A;
      background-image: url('../../assets/images/btn_bg2.png');
      background-size: 100% 100%;
    }
    .confirm {
      color: #FFFFFF;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
    }
  }
}
.topLiveBox {
  position: relative;
  margin-top: 10px;
  margin-left: 15px;
  background-color: #F4F4F4;
  border-radius: 6px;
  padding: 8px 8px 0;
  box-sizing: border-box;
  .topLiveSwipe {
    height: 100px;
    margin-right: 8px;
  }
  ::v-deep .topLiveSwipe .van-swipe-item {
    height: 100%;
  }
  ::v-deep .custom-indicator-wrapper {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    background-color: #FFFFFF;
    border-radius: 4px;
    .custom-dot {
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #D8D8D8;
      margin: 3px auto;  
    }
    .custom-dot--active{
      height: 10px;
      border-radius: 4px;
      background-color: #FF3A3A;
    }
  }
  .topLiveItem {
    display: flex;
    height: 92px;
    background-color: #FFFFFF;
    padding: 5px;
    border-radius: 6px;
    box-sizing: border-box;
    .live-cover {
      position: relative;
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
      height: 100%;
      margin-right: 8px;
      .cover {
        display: block;
        height: 100%;
        width: auto;           // 此时图片宽度由高度和宽高比决定
        max-width: 100%; 
        border-radius: 6px;
      }
      .liveStatus {
        display: flex;
        align-items: center;
        position: absolute;
        left: 5px;
        bottom: 5px;
        height: 15px;
        border-radius: 15px;
        padding: 0 5px;
        font-size: 8px;
      }
      .noLive {
        background-color: #D8D8D8;
        color: #000000;
        img {
          display: block;
          width: 10px;
          height: 10px;
          margin-right: 2px;
        }
      }
      .liveStreaming {
        background-color: #EB1700;
        color: #FFFFFF;
        img {
          display: block;
          width: 10px;
          height: 10px;
          margin-right: 2px;
        }
      }
    }
    .live-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .live-title {
        font-size: 12px;
        color: #3D3D3D;
      }
      .live-time {
        font-size: 10px;
        color: #9E9E9E;
      }
    }
  }
}
.timeline {
  width: 100%;
  margin-top: 10px;
  padding: 0 15px;
  box-sizing: border-box;
  .timeline-item {
    position: relative;
  }
  .timeline-item:not(:last-of-type) {
    margin-bottom: 10px;
  }
  .timeline-marker {
    position: relative;
    z-index: 1;
    width: 80px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 10px 22px 22px 0;
    background-color: #F4F4F4;
    font-size: 12px;
    color: #4A4A4A;
    margin-bottom: 10px;
  }
  .timeline-marker_active {
    background-color: #EB1700;
    color: #FFFFFF;
  }
  .timeline-content {
    margin-left: 10px;
    .live-time {
      position: relative;
      top: -5px;
      color: #554C47;
      font-size: 12px;
    }
    .live-item {
      display: flex;
      border-radius: 8px;
      .live-cover {
        position: relative;
        width: 50%;
        margin-right: 8px;
        .cover {
          display: block;
          width: 100%;
          border-radius: 6px;
        }
        .activityLabel {
          display: inline-block;
          height: 16px;
          line-height: 16px;
          padding: 0 4px;
          position: absolute;
          right: 4px;
          top: 4px;
          font-size: 8px;
          color: #FFFFFF;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 4px;
        }
        .liveStatus {
          display: flex;
          align-items: center;
          position: absolute;
          left: 5px;
          bottom: 5px;
          height: 15px;
          border-radius: 15px;
          padding: 0 5px;
          font-size: 8px;
          img {
            display: block;
            width: 9px;
            margin-right: 2px;
          }
        }
        .noLive {
          background-color: #D8D8D8;
          color: #000000;
        }
        .liveStreaming {
          background-color: #EB1700;
          color: #FFFFFF;
        }
      }
      .live-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        .live-title {
          font-size: 12px;
          color: #3D3D3D;
        }
        .live-time {
          font-size: 10px;
          color: #9E9E9E;
        }
      }
    }
    .live-item:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  .timeline-item::before {
    content: '';
    position: absolute;
    left: 0px;
    top: 4px;
    width: 1px;
    height: calc(100% + 22px);
    z-index: 0;
    background: repeating-linear-gradient(to bottom,
      #D8D8D8 0px,
      #D8D8D8 4px,
      transparent 6px,
      transparent 8px);
  }
  .timeline-item:last-child::before {
    // display: none;
    height: 100%;
  }
}
.activityList {
  width: 100%;
  margin-top: 10px;
  padding: 0 15px;
  box-sizing: border-box;
  .activityItem {
    position: relative;
    border-radius: 16px;
    box-shadow: 0 3px 10px -4px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    .cover {
      display: block;
      width: 100%;
    }
    .info {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 20px 10px 8px;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
      color: #FFFFFF;
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .time {
        font-size: 10px;
        margin-top: 2px;
      }
    }
  }
  .activityItem:not(:last-child) {
    margin-bottom: 10px;
  }
}


</style>
